import { combineReducers, createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import auth from './auth/reducers';
import settings from './settings/reducers';
import marks from './marks/reducers';
import jewels from './jewels/reducers';


const reducers = combineReducers({
    auth,
    settings,
    marks,
    jewels
});

const persistConfig = {
    key: 'primary',
    storage,
    whitelist: ['auth']
}

const persistedReducer = persistReducer(persistConfig, reducers);


export default () => {
    let store = createStore(persistedReducer,  {} ,composeWithDevTools(applyMiddleware(thunk)));
    let persistor = persistStore(store);
    return { store, persistor }
}